import { gql } from '@apollo/client';

export const pageOwners = gql`
  query ($amount: Int!, $field: String!, $page: Int!, $filters: [FilterInput!], $csv: Boolean) {
    pageOwners(grid: { amount: $amount, field: $field, page: $page, filters: $filters, csv: $csv }) {
      count
      data {
        PhysOwnerDeptId
        userId
        userName
        PhysicalOwner
        DepartmentId
        Description
      }
    }
  }
`;

export const searchOwners = gql`
  query ($input: String!) {
    searchOwnerByName(input: $input) {
      PhysOwnerDeptId
      userId
      userName
      PhysicalOwner
      DepartmentId
      Description
    }
  }
`;

export const batchUpdateOwnerMutation = gql`
  mutation ($owners: [OwnerInput!]!) {
    batchUpdateOwner(owners: $owners)
  }
`;

export const getDepartments = gql`
  query {
    readAllDepartments: readDepartments {
      id
      Name
    }
  }
`;

export const updateOwnerInline = gql`
  mutation ($owner: OwnerInput!, $userName: String!, $userId: Float!){
    updateOwnerInLine(owner: $owner, userName: $userName, userId: $userId){
      userId
    }
  }
`

export const getUsers = gql`
  query{
    readUsers: readAllApplicationUsers {
      id
      name
    }
  }
`
